import moment from "moment";

export default class POSReportOperation {
  operationData;
  constructor(operation) {
    this.operationData = operation;
  }

  get dateTime() {
    let _dateTimeString = this.operationData.date_time;

    _dateTimeString = `${_dateTimeString.slice(0, 3)}-${_dateTimeString.slice(
      4,
      5
    )}-${_dateTimeString.slice(6, 7)} ${_dateTimeString.slice(
      8,
      9
    )}:${_dateTimeString.slice(10, 11)}:${_dateTimeString.slice(12, 13)}`;

    const _dateTimeObj = moment(_dateTimeString);

    return {
      date: _dateTimeObj.format("DD.MM.YYY"),
      time: _dateTimeObj.format("HH:mm:ss"),
    };
  }

  get amount() {
    return (parseInt(this.operationData.amount) / 100).toFixed(2);
  }

  get status() {
    return this.operationData.response;
  }
}
